module.exports = __webpack_public_path__ + "static/dusanstvo_sluzby-f80ed169dc16838ee97267d462802000.jpg";